// extracted by mini-css-extract-plugin
export var back = "PortfolioLayout-module--back--c0b47";
export var back__icon = "PortfolioLayout-module--back__icon--b7fe9";
export var body = "PortfolioLayout-module--body--3d4c2";
export var head = "PortfolioLayout-module--head--519c6";
export var isDark = "PortfolioLayout-module--is-dark--e9775";
export var isScroll = "PortfolioLayout-module--is-scroll--b6cac";
export var wrap = "PortfolioLayout-module--wrap--0be3a";